<template>
  <div class="col-md-12">
    <Form @submit="handleForm">
      <div>
        <Header></Header>
        <div class="header-group">
          <h1><img src="@/assets/img/underline.png" alt="">NOUVEAU MOT DE PASSE</h1>
        </div>

        <PasswordField
            :show-toggle="false"
            name="password"
            placeholder="Mot de passe*"
            autocomplete="new-password"
        />
        <PasswordField
            :is-confirmation="true"
            :show-toggle="false"
            name="password2"
            password-field-name="password"
            placeholder="Confirmer le mot de passe*"
            autocomplete="new-password"
        />

        <div class="form-group">
          <button :disabled="isDisabled" class="btn btn-primary btn-block">
            <span v-show="loading" class="spinner-border spinner-border-sm"></span>
            Réinitialiser le mot de passe
          </button>
        </div>
      </div>
    </Form>

    <div
        v-if="message"
        :class="successful ? 'alert-success' : 'alert-danger'"
        class="alert"
    >
      {{ message }}
    </div>
  </div>
</template>

<script>
import {ErrorMessage, Field, Form} from "vee-validate";

import Header from '@/views/public/newAccount/Header.vue';
import PasswordField from "@/components/PasswordField.vue";
import AuthApi from "@/api/AuthApi";
import RouteEnum from "@/router/RouteEnum";
import router from '@/router/router'

export default {
  name: "PasswordForgotten",
  components: {
    Form,
    Field,
    ErrorMessage,
    Header,
    PasswordField
  },
  data() {
    return {
      loading: false,
      message: null,
      successful: false,
      token: this.$route.params.token
    };
  },
  computed: {
    isDisabled: function () {
      return this.loading;
    },
  },
  methods: {
    handleForm(form) {
      this.loading = true
      AuthApi.sendNewPassword(this.token, form.password).then(
          (response) => {
            this.message = response.data.message
            this.successful = true
            setTimeout(function (router) {
              router.push({name: RouteEnum.LOGIN});
            }, 4000, router)
          },
          (error) => {
            this.message = error.response.data.detail
            this.successful = false
            this.loading = false
          }
      );
    },
  }
};
</script>
